import React, { FC, useEffect } from "react";
import { Box } from "@mui/material";
import { applyUtmsToHubspotForm } from "@src/helpers/utms";

interface HubspotGenericFormProps {
  region?: string;
  portalId?: string;
  formId: string;
  successCallback?(form: any): void;
}

const HubspotGenericForm: FC<HubspotGenericFormProps> = ({
  region = "na1",
  portalId = "21503852",
  formId,
  successCallback,
}) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          target: "#hubspotForm",
          onFormReady: ($form: HTMLFormElement) => {
            applyUtmsToHubspotForm($form);
          },
          onFormSubmit: ($form: HTMLFormElement) => {
            try {
              if (successCallback) {
                successCallback($form);
              }
            } catch (ignore) {}
          },
        });
      }
    });
  }, []);

  return (
    <Box
      id="hubspotForm"
      sx={{ width: "100%", maxWidth: "720px", marginX: "auto" }}
    />
  );
};

export default HubspotGenericForm;
